import { axios } from '@/utils/request'
import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
import { MTC_AUTH } from '@api/servers'

/**
 * login func
 * params: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param params
 * @returns {*}
 */
export const login = params => postAction(`${ MTC_AUTH }sys/login`, params)
export const phoneLogin = params => postAction(`${ MTC_AUTH }sys/phoneLogin`, params)
export const getSmsCaptchaparams = params => postAction(`${ MTC_AUTH }account/sms`, params)
export const logout = params => {
  return axios({
    url: `${ MTC_AUTH }sys/logout`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token': params
    }
  })
}
/**
 * 第三方登录
 * @param token
 * @param thirdType
 * @returns {*}
 */
export const thirdLogin = ( token, thirdType ) => {
  return axios({
    url: `${ MTC_AUTH }sys/thirdLogin/getLoginUser/${ token }/${ thirdType }`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// export function getInfo() {
//   return axios({
//     url: '/api/user/info',
//     method: 'get',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }